import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import React from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncSearchResults = Load(
  () =>
    import(
      /* webpackChunkName: "experiences-page" */ './containers/ExperiencesContainer'
    ),
  {},
  true,
);

export const experiencesRoute: RouteDescriptor = {
  id: 'experiences.list',
  path: `${basePath}/experiences/*`,
  label: 'Experiences',
  audience: 'both',
  layout: 'navigational',
  module: 'experiences',
};

const ExperiencesRoutes = [
  createNavigationalRoute({
    path: experiencesRoute.path,
    component: AsyncSearchResults,
    showBottomNavigation: true,
    showSearchInNavbar: true,
    id: experiencesRoute.id,
    handle: createRouteHandle(experiencesRoute),
  }),
];

const ExperiencesAppRedirect = () => {
  const location = useLocation();
  const suffix = location.pathname.replace(`${basePath}/experiences`, '');

  return (
    <Navigate
      to={`${basePath}/s${suffix}${location.search}`}
      replace
      state={location.state}
    />
  );
};

export const experiencesRedirectRoute: RouteDescriptor = {
  id: 'experiences.redirect',
  path: `${basePath}/experiences/*`,
  label: 'Experiences Redirect',
  audience: 'both',
  layout: 'standalone',
  module: 'experiences',
};

const RedirectForApps = (
  <Route
    key={experiencesRedirectRoute.id}
    id={experiencesRedirectRoute.id}
    path={experiencesRedirectRoute.path}
    handle={createRouteHandle(experiencesRedirectRoute)}
    element={<ExperiencesAppRedirect />}
  />
);

export const experiencesRoutes = isCordova()
  ? [RedirectForApps]
  : ExperiencesRoutes;

export const experiencesRouteDescriptors = [
  experiencesRoute,
  experiencesRedirectRoute,
];

export default experiencesRoutes;
